import './setupResizeObserver';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/color-system.css';
import './styles/sticky-bar-buttons.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';

// ✨ Suppress ResizeObserver loop errors from @xyflow/react (harmless browser API warnings)
if (typeof window !== 'undefined') {
  // Method 1: Global error handler for ResizeObserver errors
  const resizeObserverErrHandler = (event) => {
    const isResizeObserverError = 
      event.message === 'ResizeObserver loop completed with undelivered notifications.' ||
      event.message === 'ResizeObserver loop limit exceeded' ||
      event.message?.includes('ResizeObserver loop completed') ||
      (event.error && event.error.message && event.error.message.includes('ResizeObserver'));
    
    if (isResizeObserverError) {
      event.stopImmediatePropagation();
      event.preventDefault();
      return true;
    }
  };
  window.addEventListener('error', resizeObserverErrHandler);

  // Method 2: Handle unhandledrejection for ResizeObserver promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason?.message?.includes('ResizeObserver loop completed')) {
      event.preventDefault();
    }
  });

  // Method 3: Override console.error to filter ResizeObserver and React Flow warnings
  const originalConsoleError = console.error;
  console.error = (...args) => {
    const firstArg = args[0];
    const isResizeObserverError = 
      (typeof firstArg === 'string' && firstArg.includes('ResizeObserver')) ||
      (firstArg instanceof Error && firstArg.message.includes('ResizeObserver'));
    
    // Also suppress React Flow handle errors (these are fixed but may appear during data load)
    const isReactFlowHandleError = 
      (typeof firstArg === 'string' && firstArg.includes('[React Flow]: Couldn\'t create edge'));
    
    if (!isResizeObserverError && !isReactFlowHandleError) {
      originalConsoleError.apply(console, args);
    }
  };

  // Method 4: Global window.onerror handler as backup
  const originalOnError = window.onerror;
  window.onerror = function(message, source, lineno, colno, error) {
    if (typeof message === 'string' && message.includes('ResizeObserver')) {
      return true; // Suppress the error
    }
    if (originalOnError) {
      return originalOnError(message, source, lineno, colno, error);
    }
    return false;
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <GoogleOAuthProvider clientId="488073068533-4tf0p1j3kr7eqhk7vrajvp5mtj0og0ms.apps.googleusercontent.com">
      <App />
    </GoogleOAuthProvider>
  </>
);

reportWebVitals();
